<div class="container">
	@if (!foundMedicationIncidents()?.length) {
		<empty-state
			data-test="empty-found-medication-incidents-list"
			icon="fa fae-medicine fa-rotate-90"
			message="{{ 'medication.found_medication_incidents.empty' | translate }}"
		/>
	} @else {
		@for (medicationIncident of foundMedicationIncidents(); track medicationIncident) {
			<ic-medication-incident-list-item [incident]="medicationIncident" />
		}
		<span class="total-records-message"
			>{{
				"medication.found_medication_incidents.total_incidents_message"
					| translate: { incidentCount: foundMedicationIncidents().length }
			}}
		</span>
	}

	<ion-fab horizontal="end" slot="fixed" vertical="bottom">
		<ion-fab-button data-test="create-found-medication-incident-button" (click)="gotoCreateFoundMedicationIncident()">
			<i class="fa fa-plus"></i>
		</ion-fab-button>
	</ion-fab>
</div>
